import api from './api';

// 获取系统配置
export const getSystemConfig = async (keys = []) => {
  try {
    let url = '/system/config';
    if (keys && keys.length > 0) {
      url += `?keys=${keys.join(',')}`;
    }
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('获取系统配置失败:', error);
    throw error;
  }
};

// 更新系统配置
export const updateSystemConfig = async (configData) => {
  try {
    const response = await api.put('/system/config', configData);
    return response.data;
  } catch (error) {
    console.error('更新系统配置失败:', error);
    throw error;
  }
};

// 获取公共配置（无需登录）
export const getPublicConfig = async (keys = []) => {
  try {
    let url = '/public/system/config';
    if (keys && keys.length > 0) {
      url += `?keys=${keys.join(',')}`;
    }
    
    // 使用不带认证的请求
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('获取公共配置失败:', error);
    throw error;
  }
};
